// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"isB72":[function(require,module,exports,__globalThis) {
/* eslint-disable max-len */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _mobileNav = require("./mobileNav");
var _mobileNavDefault = parcelHelpers.interopDefault(_mobileNav);
var nav = {
    settings: {
        navElement: document.querySelector('.header__nav'),
        hamburgerListener: false
    },
    init: function() {
        if (window.matchMedia('(min-width: 1280px)').matches) {
            this.navigationHover();
            this.navigationScroll();
        } else {
            this.mobileAccordion();
            (0, _mobileNavDefault.default).init();
            this.hamburger();
        }
        this.search();
        window.addEventListener('resize', this.handleResize);
    },
    search: function() {
        var search = document.querySelector('.header__search svg');
        var searchContainer = document.querySelector('.header__search__container');
        var closeSearch = document.querySelector('.header__search__close');
        var suggestions = document.querySelectorAll('.header__search__sugestions p');
        var input = document.querySelector('.header__search input');
        var form = document.querySelector('.header__search form');
        search.addEventListener('click', function() {
            search.parentElement.classList.toggle('var_open');
        });
        document.addEventListener('click', function(e) {
            if (!searchContainer.contains(e.target) && !search.contains(e.target)) search.parentElement.classList.remove('var_open');
        });
        closeSearch.addEventListener('click', function() {
            closeSearch.parentElement.parentElement.classList.remove('var_open');
        });
        suggestions.forEach(function(suggestion) {
            suggestion.addEventListener('click', function() {
                var searchText = this.textContent;
                input.value = searchText;
                form.submit();
            });
        });
    },
    navigationScroll: function() {
        var header = document.querySelector('.header');
        if (!header) return;
        var scrollY = window.scrollY;
        window.addEventListener('scroll', function() {
            scrollY = window.scrollY;
            if (scrollY > 10) header.classList.add('active');
            else header.classList.remove('active');
        });
    },
    hamburger: function() {
        if (!nav.settings.hamburgerListener) {
            var hamburger = document.querySelector('.header__hamburger');
            hamburger.addEventListener('click', function() {
                nav.settings.navElement.style.transition = 'opacity 0.3s ease-in-out, visibility 0.3s ease-in-out';
                hamburger.classList.toggle('var_open');
                nav.settings.navElement.classList.toggle('var_open');
                if ((0, _mobileNavDefault.default).settings.mobileNavEl) (0, _mobileNavDefault.default).settings.mobileNavEl.classList.toggle('active');
            });
        }
        nav.settings.hamburgerListener = true;
    },
    navigationHover: function() {
        var navElementsWithChildren = document.querySelectorAll('.main-children.menu-item-has-children');
        navElementsWithChildren.forEach(function(navElementWithChildren) {
            navElementWithChildren.addEventListener('mouseenter', function() {
                var childrenContainer = navElementWithChildren.querySelector('.header__nav__children');
                var prevElement = document.querySelector('.header__nav__children.var_open');
                var prevChildrenElements = document.querySelectorAll('.header__nav__children.var_open ul.var_open');
                var prevHoverElement = document.querySelectorAll('li.var_hover');
                prevElement === null || prevElement === void 0 ? void 0 : prevElement.removeAttribute('style');
                nav.setHeightOfOpenNavigation(childrenContainer);
                prevElement === null || prevElement === void 0 ? void 0 : prevElement.classList.remove('var_open');
                prevChildrenElements === null || prevChildrenElements === void 0 ? void 0 : prevChildrenElements.forEach(function(prevChildrenElement) {
                    return prevChildrenElement.classList.remove('var_open');
                });
                prevHoverElement === null || prevHoverElement === void 0 ? void 0 : prevHoverElement.forEach(function(el) {
                    return el.classList.remove('var_hover');
                });
                navElementWithChildren.classList.add('var_hover');
                childrenContainer.classList.add('var_open');
            });
        });
        var mainChildrens = document.querySelectorAll('.header__nav__container > .menu-item-has-children');
        mainChildrens.forEach(function(mainChildren) {
            mainChildren.addEventListener('mouseenter', function() {
                var children = mainChildren.querySelector('.header__nav__subchildren');
                var prevElement = document.querySelector('.header__nav__subchildren.var_open');
                var prevHoverElement = document.querySelector('.header__nav__container > .menu-item-has-children.var_hover');
                prevElement === null || prevElement === void 0 ? void 0 : prevElement.classList.remove('var_open');
                prevHoverElement === null || prevHoverElement === void 0 ? void 0 : prevHoverElement.classList.remove('var_hover');
                mainChildren.classList.add('var_hover');
                children.classList.add('var_open');
            });
        });
        var subChildrens = document.querySelectorAll('.header__nav__subchildren .menu-item-has-children');
        subChildrens.forEach(function(subChildren) {
            subChildren.addEventListener('mouseenter', function() {
                var children = subChildren.querySelector('.header__nav__subsubchildren');
                var prevElement = document.querySelector('.header__nav__subsubchildren.var_open');
                var prevHoverElement = document.querySelector('.header__nav__subchildren .menu-item-has-children.var_hover');
                prevElement === null || prevElement === void 0 ? void 0 : prevElement.classList.remove('var_open');
                prevHoverElement === null || prevHoverElement === void 0 ? void 0 : prevHoverElement.classList.remove('var_hover');
                subChildren.classList.add('var_hover');
                children.classList.add('var_open');
            });
        });
        var childrensWithoutSubmenu = document.querySelectorAll('.header__nav__container > .menu-item:not(.menu-item-has-children), .header__nav__subchildren > .menu-item:not(.menu-item-has-children)');
        childrensWithoutSubmenu.forEach(function(childrenWithoutSubmenu) {
            childrenWithoutSubmenu.addEventListener('mouseenter', function() {
                var parentElement = childrenWithoutSubmenu.parentElement;
                var hoverElements = parentElement.querySelector('.var_hover');
                var openChildren = parentElement.querySelector('.var_open');
                hoverElements === null || hoverElements === void 0 ? void 0 : hoverElements.classList.remove('var_hover');
                openChildren === null || openChildren === void 0 ? void 0 : openChildren.classList.remove('var_open');
            });
        });
        var navElementsWithoutChildren = document.querySelectorAll('.main-children:not(.menu-item-has-children)');
        navElementsWithoutChildren.forEach(function(navElementWithoutChildren) {
            navElementWithoutChildren.addEventListener('mouseenter', function() {
                nav.clearOpenMenu();
            });
        });
        document.querySelectorAll('.header__nav__children').forEach(function(navContainer) {
            navContainer.addEventListener('mouseleave', function() {
                nav.clearOpenMenu();
            });
        });
    },
    clearOpenMenu: function() {
        var _document_querySelector, _document_querySelectorAll, _document_querySelectorAll1;
        (_document_querySelector = document.querySelector('.header__nav__children.var_open')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.remove('var_open');
        (_document_querySelectorAll = document.querySelectorAll('ul.var_open')) === null || _document_querySelectorAll === void 0 ? void 0 : _document_querySelectorAll.forEach(function(el) {
            return el.classList.remove('var_open');
        });
        (_document_querySelectorAll1 = document.querySelectorAll('li.var_hover')) === null || _document_querySelectorAll1 === void 0 ? void 0 : _document_querySelectorAll1.forEach(function(el) {
            return el.classList.remove('var_hover');
        });
    },
    setHeightOfOpenNavigation: function(childrenContainer) {
        var _Math;
        var getSubNavigations = childrenContainer.querySelectorAll('.header__nav__container, .header__nav__subchildren, .header__nav__subsubchildren');
        var heightArray = [];
        getSubNavigations.forEach(function(subNavigation) {
            heightArray.push(subNavigation.offsetHeight);
        });
        var maxHeight = (_Math = Math).max.apply(_Math, (0, _toConsumableArray._)(heightArray));
        var getPaddingTop = parseFloat(window.getComputedStyle(childrenContainer).paddingTop);
        var getPaddingBottom = parseFloat(window.getComputedStyle(childrenContainer).paddingBottom);
        childrenContainer.style.height = "".concat(maxHeight + getPaddingTop + getPaddingBottom, "px");
    },
    mobileAccordion: function() {
        var openers = document.querySelectorAll('.header__arrow');
        openers.forEach(function(opener) {
            opener.addEventListener('click', function() {
                var children = opener.nextElementSibling;
                children.classList.toggle('var_open');
                if (children.classList.contains('var_open')) children.style.position = 'relative';
                else setTimeout(function() {
                    return children.style.position = 'absolute';
                }, 300);
            });
        });
    },
    handleResize: function() {
        nav.hamburger();
        nav.settings.navElement.removeAttribute('style');
    }
};
nav.init();

},{"@swc/helpers/_/_to_consumable_array":"fRXIP","./mobileNav":"eAYCz","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fRXIP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_consumable_array;
});
var _arrayWithoutHolesJs = require("./_array_without_holes.js");
var _iterableToArrayJs = require("./_iterable_to_array.js");
var _nonIterableSpreadJs = require("./_non_iterable_spread.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _to_consumable_array(arr) {
    return (0, _arrayWithoutHolesJs._)(arr) || (0, _iterableToArrayJs._)(arr) || (0, _unsupportedIterableToArrayJs._)(arr) || (0, _nonIterableSpreadJs._)();
}

},{"./_array_without_holes.js":"aJNWK","./_iterable_to_array.js":"4dRp5","./_non_iterable_spread.js":"5bLVB","./_unsupported_iterable_to_array.js":"hj6r8","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"aJNWK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_without_holes;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return (0, _arrayLikeToArrayJs._)(arr);
}

},{"./_array_like_to_array.js":"2PDXV","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2PDXV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_like_to_array;
});
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"iRwqC":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"4dRp5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array;
});
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5bLVB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_spread;
});
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hj6r8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _unsupported_iterable_to_array;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, _arrayLikeToArrayJs._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, _arrayLikeToArrayJs._)(o, minLen);
}

},{"./_array_like_to_array.js":"2PDXV","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"eAYCz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var mobileNav = {
    settings: {
        mobileNavEl: null
    },
    init: function() {
        mobileNav.settings.mobileNavEl = document.querySelector('.nav-mobile');
        if (!mobileNav.settings.mobileNavEl) return;
        var mainChildren = mobileNav.settings.mobileNavEl.querySelectorAll('.menu-item-has-children a');
        mainChildren.forEach(function(item) {
            item.addEventListener('click', function(e) {
                var subMenu = item.parentNode.querySelector('.nav-mobile__submenu');
                if (subMenu) {
                    e.preventDefault();
                    subMenu.classList.add('active');
                }
                if (item.parentNode.classList.contains('js-not-a-link')) {
                    e.preventDefault();
                    item.parentNode.querySelector('.nav-mobile__submenu__level').classList.toggle('active');
                    item.parentNode.querySelector('.expand-menu').classList.toggle('active');
                    item.parentNode.classList.toggle('active');
                }
            });
        });
        mobileNav.mobileMenuNavigationBack();
        mobileNav.mobileMenuNavigationClose();
    },
    mobileMenuNavigationBack: function() {
        var navMobileBack = document.querySelectorAll('.nav-mobile__back');
        if (!navMobileBack.length) return;
        navMobileBack.forEach(function(item) {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                item.parentNode.parentNode.classList.remove('active');
            });
        });
    },
    mobileMenuNavigationClose: function() {
        var navMobileClose = document.querySelectorAll('.nav-mobile__close');
        if (!navMobileClose.length) return;
        navMobileClose.forEach(function(item) {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                item.parentNode.parentNode.classList.remove('active');
                mobileNav.resetAllMenuItems();
            });
        });
    },
    resetAllMenuItems: function() {
        var allSubMenus = mobileNav.settings.mobileNavEl.querySelectorAll('ul');
        if (!allSubMenus.length) return;
        allSubMenus.forEach(function(submenu) {
            submenu.classList.remove('active');
        });
        mobileNav.settings.mobileNavEl.classList.remove('active');
        document.querySelector('.header__hamburger').classList.remove('var_open');
        var jsNotALink = document.querySelectorAll('.js-not-a-link');
        if (!jsNotALink.length) return;
        jsNotALink.forEach(function(subMenuParent) {
            subMenuParent.classList.remove('active');
        });
    }
};
exports.default = mobileNav;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}]},["isB72"], "isB72", "parcelRequire94c2")

//# sourceMappingURL=nav.js.map
